import React from 'react';
import PropTypes from 'prop-types';
import {
    HorizontalFlex,
    Modal,
    ModalBody,
    ModalFooterConfirmDismiss,
    ModalHeader,
} from 'smartsuite-ui';
import { useLabelContext } from '../shared/hooks/labelContext';

export default function DeleteCustomDashboardModal(props) {
    const { dashboardLabels, translationLabels } = useLabelContext();

    return (
        <Modal onOverlayClick={props.onDismiss}>
            <ModalHeader onDismiss={props.onDismiss}>
                <span>{dashboardLabels.deleteDashboard}</span>
            </ModalHeader>
            <ModalBody>
                <HorizontalFlex>
                    <span>{dashboardLabels.confirmCustomDashboardDelete}</span>
                </HorizontalFlex>
            </ModalBody>
            <ModalFooterConfirmDismiss
                confirmLabel={translationLabels.delete}
                dismissLabel={translationLabels.cancel}
                onConfirm={props.deleteDashboard}
                onDismiss={props.onDismiss}
            />
        </Modal>
    );
}

DeleteCustomDashboardModal.propTypes = {
    deleteDashboard: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};
